import { render, staticRenderFns } from "./ListBlClient.vue?vue&type=template&id=4d2d9bb5&scoped=true&"
import script from "./ListBlClient.vue?vue&type=script&lang=js&"
export * from "./ListBlClient.vue?vue&type=script&lang=js&"
import style0 from "./ListBlClient.vue?vue&type=style&index=0&id=4d2d9bb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2d9bb5",
  null
  
)

export default component.exports